import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyanmar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1672)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2536 16.1739C23.736 14.874 24 13.4678 24 12C24 10.5322 23.736 9.12605 23.2536 7.82611L12 6.78262L0.746391 7.82611C0.264047 9.12605 0 10.5322 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739L12 17.2174L23.2536 16.1739Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.2536 7.82611C21.5581 3.2565 17.1596 0 12 0C6.84043 0 2.44191 3.2565 0.746399 7.82611H23.2536Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.2289 10.1525H13.9426L12 4.17389L10.0574 10.1525H3.77115L8.85685 13.8474L6.91426 19.8261L12 16.1739L17.0858 19.8261L15.1432 13.8474L20.2289 10.1525Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1672",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMyanmar;
